import { render, staticRenderFns } from "./Constructor.vue?vue&type=template&id=addc1626&scoped=true"
import script from "./Constructor.vue?vue&type=script&lang=js"
export * from "./Constructor.vue?vue&type=script&lang=js"
import style0 from "./Constructor.vue?vue&type=style&index=0&id=addc1626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addc1626",
  null
  
)

export default component.exports